export type SubscriptionStatus =
    | 'active'
    | 'canceled'
    | 'incomplete'
    | 'incomplete_expired'
    | 'past_due'
    | 'trialing'
    | 'unpaid';

export enum SubscriptionStatusTypes {
    active ='active',
    canceled = 'canceled',
    incomplete = 'incomplete',
    incomplete_expired = 'incomplete_expired',
    past_due = 'past_due',
    trialing = 'trialing',
    unpaid = 'unpaid'
}

export type SubscriptionInterval = 'day' | 'month' | 'week' | 'year';

export type InvoiceStatus =
    | 'deleted'
    | 'draft'
    | 'open'
    | 'paid'
    | 'uncollectible'
    | 'void';

export enum InvoiceStatusTypes {
    deleted = 'deleted',
    draft = 'draft',
    open = 'open',
    paid = 'paid',
    uncollectible = 'uncollectible',
    void = 'void'
}

export type CardBrand =
    | 'amex'
    | 'diners'
    | 'discover'
    | 'jcb'
    | 'mastercard'
    | 'unionpay'
    | 'visa'
    | 'unknown'

export enum CardBrands {
    amex = 'amex',
    diners = 'diners',
    discover = 'discover',
    jcb = 'jcb',
    mastercard = 'mastercard',
    unionpay = 'unionpay',
    visa = 'visa',
    unknown = 'unknown'
}

export type CouponDuration = 'forever' | 'once' | 'repeating'

export enum CouponDurations {
    forever = 'forever',
    once = 'once',
    repeating = 'repeating',
}